import { render } from "./BiosamplesTable.vue?vue&type=template&id=4d71476c&scoped=true"
import script from "./BiosamplesTable.vue?vue&type=script&lang=js"
export * from "./BiosamplesTable.vue?vue&type=script&lang=js"

import "./BiosamplesTable.vue?vue&type=style&index=0&id=4d71476c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d71476c"]])

export default __exports__